import BaseModel from './BaseModel';
import ArticleAttributeChoice from './ArticleAttributeChoice';

/** Class representing an article attribute. */
class ArticleAttribute extends BaseModel {
    constructor(properties) {
        super(properties);

        this.choices = (this.choices || []).map(c => new ArticleAttributeChoice(c));
    }

    isFeature() {
        // Number('') and Number(null) are 0; those must stay extras, not features.
        return this.max_nb_choices !== null
            && this.max_nb_choices !== ''
            && Number(this.max_nb_choices) === 0;
    }

    isExtra() {
        return !this.isFeature();
    }

    isRequiredExtra() {
        return this.isExtra() && this.min_nb_choices > 0;
    }
}

export default ArticleAttribute;
